import { baseSeriesMark } from "../base/constant";

export const correlationSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    nodePoint: {
        name: "nodePoint",
        type: "symbol"
    },
    ripplePoint: {
        name: "ripplePoint",
        type: "ripple"
    },
    centerPoint: {
        name: "centerPoint",
        type: "symbol"
    },
    centerLabel: {
        name: "centerLabel",
        type: "text"
    }
});
//# sourceMappingURL=constant.js.map
